import { Notification } from '@dtpk-cc/components';
import { pluginSettingsVar } from '../../../apollo/store';

export const AutoConfigCheckError = () => {
    const { linkToProductOverview } = pluginSettingsVar();

    return (
        <Notification variant={Notification.Variant.alert} closable={false} noSideMargins noBottomMargin>
            <Notification.Headline>Es sind Fehler bei der Produktkonfiguration aufgetreten.</Notification.Headline>
            <Notification.CopyText data-test-error="product-config-error">
                Sie haben die Möglichkeit Ihr Produkt in der Tarifübersicht selbst zu konfigurieren.
            </Notification.CopyText>
            <Notification.Link href={linkToProductOverview} data-test-action="do-manual-booking-for-address">
                Weiter zur Tarifübersicht
            </Notification.Link>
        </Notification>
    );
};
